 <template>
    <gj-modal size="400Auto" v-bind="$attrs" v-on="$listeners" :visible.sync="modalVisible"
        class="limit-details-modal">
        <template #header>今日额度详情</template>
        <template #content>
            <div class="tool-group-mail">
                今日发件额度
                <gj-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">使用说明：亚马逊规定卖家每日给买家<br/>发邮件的数量在(600+5*日均单量)之内<br/>计算公式：所有店铺站点发件额度之和</div>
                    <i class="el-icon-question fontsize12 colorD8DADD gj-ml5 gj-mr16"></i>
                </gj-tooltip>
                <el-progress style="width:200px;border-radius: 4px;margin-right: 12px" :text-inside="true" :stroke-width="14"
                    :show-text="false" :percentage="mailPackForm.alreadySendMailRate" :color="mailPackForm.color"></el-progress>
                <span :style="{color: mailPackForm.color}">剩余{{ mailPackForm.dayExcessMailCount }}</span>
            </div>
            <gj-table :data="mailPackForm.marketMailDetailList" :index="false" :columns="columns" :height="350"
                :adapt-height="false" style="margin-top:20px">
                <template v-slot:dayMailCount="{ row }">
                    <el-tooltip
                        placement="top"
                        effect="dark"
                        :content="row.alreadySendMailCount + '/' + row.dayMailCount">
                        <el-progress :text-inside="true" :stroke-width="10"
                            :show-text="false" style="border-radius: 4px;" :percentage="row.alreadySendMailRate" :color="row.color">
                        </el-progress>
                    </el-tooltip>
                </template>
                <template v-slot:excessMailCount="{ row }">
                    <span>{{moneyFormat(row.excessMailCount)}}</span>
                </template>
            </gj-table>
        </template>
    </gj-modal>
</template>

<script>
import { modalMixIn } from "./../../../../../minxins";
export default {
    name: "send-rule-limit-details",
    mixins: [modalMixIn],
    props: {
        mailPackForm: Object
    },
    data() {
        return {
            data: [],
            columns: [
                { id: 'marketName', header: '店铺名称', field: 'marketName', minWidth: '130px' },
                { id: 'dayMailCount', header: '已发邮件数/今日总额度', field: 'slot:dayMailCount', minWidth: '200px' },
                { id: 'excessMailCount', header: '剩余额度', field: 'slot:excessMailCount', minWidth: '80px' },
            ]
        }
    },
    methods: {
        // 整数金额格式化
        moneyFormat (num) {
            return String(num).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        }
    }
}
</script>

<style lang="scss">
.limit-details-modal {
    .tool-group-mail {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
            cursor: pointer;
            margin: 0px 16px;
            width: 15px;
            height: 15px;
        }
    }

    div.el-dialog {
        width: 500px !important;
        height: 500px !important;
    }
}
</style>
